/**
 * applicable-dogs.js
 */

import React from 'react';
import { Collapse, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import Alert from '@mui/material/Alert';
import Icon from 'components/icon';
import { shouldRenderMobileLayout } from 'utils/app-context';


const useStyles = makeStyles(theme => ({
  memberRow: {
    display: 'flex',
    [theme.breakpoints.down(450)]: {
      flexDirection: 'column',
      marginBottom: theme.spacing(1),
    }
  },
  memberName: {
    width: 200
  },
  memberDogs: {
    flex: 1,
  },
  memberDog: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '& .pt-icon': {
      fontSize: theme.typography.sizes[2],
      marginRight: theme.spacing(0.25),
    }
  },
  memberDogApplies: {
    color: theme.palette.grey.colors[3],
  },
  memberDogNotApplies: {
    color: theme.palette.grey.colors[6],
    textDecoration: 'line-through',
  }
}));


export default function ApplicableDogs(props) {
  const { handlerList } = props;
  const classes = useStyles();
  const [alertOpen, setAlertOpen] = React.useState(true);
  let allDogsAreApplicable = true;

  
  handlerList.forEach((handler) => {
    if (handler.dogs.find(d => !d.appliesToExercise)) {
      allDogsAreApplicable = false;
    };
  })


  return (
    <>
      {handlerList.map(handler =>
        <div
          key={handler.id}
          className={classes.memberRow}
        >
          <div className={classes.memberName}>{handler.name}</div>
          <div className={classes.memberDogs}>
            {handler.dogs.map((dog, i) =>
              <div
                key={dog.id}
                className={clsx({
                  [classes.memberDog]: true,
                  [classes.memberDogApplies]: dog.appliesToExercise,
                  [classes.memberDogNotApplies]: !dog.appliesToExercise
                })}
              >
                {(dog.name.toLowerCase().includes('k9') ? dog.name : `K9 ${dog.name}`)
                  + (i < handler.dogs.length - 1 ? ', ' : '')}
              </div>)}
          </div>
        </div>)}

        {!allDogsAreApplicable &&
        <div style={{ marginTop: 24 }}>
          <Collapse in={alertOpen}>
            <Alert
              severity="info"
              action={
                <>
                  {!shouldRenderMobileLayout() &&
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setAlertOpen(false);
                    }}
                  >
                    <Icon type='close' />
                  </IconButton>}
                </>
              }
            >
              Some of the dogs at the event aren't configured to complete this type of exercise.
              If this is unexpected then one of the handlers may need to open their Dogs page and select
              appropriate <strong>Patrol</strong> and <strong>Detection Odor</strong> types
              for any misconfigured dogs.
            </Alert>
          </Collapse>
        </div>}     
    </>
  );
}